import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './confirmDeleteBlacklistDialog.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Close, Delete } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { DELETE_BLACKLIST } from '@/modules/API/software/blacklist'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmDeleteBlacklistDialogProps {
    open: boolean
    handleClose: () => void
    email: string
    deleteBlacklist?: (email: string) => void
}

const ConfirmDeleteBlacklistDialog: FunctionComponent<ConfirmDeleteBlacklistDialogProps> = ({
    open,
    handleClose,
    email,
    deleteBlacklist
}) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteOneBlacklistElement] = useMutation(DELETE_BLACKLIST, {
        variables: {
            email: email
        },
        onCompleted: () => {
            if (deleteBlacklist) deleteBlacklist(email)

            showNotificationSuccess(t('blacklistElementDeleted'))
            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorBlacklistElementDeleted'))
            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('deleteBlacklistElement')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('deleteBlacklistElementMessage')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteOneBlacklistElement}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDeleteBlacklistDialog
